import { MhcTopicFragment } from "graphqlApi/types";

export const localTopics: Record<string, MhcTopicFragment> = {};
